//  DataTables initialization detection (Vanilla JavaScript)
//  Tested with qmod version 1.35.0
//  This script is used to disable responsive functionality for DataTables in Qmod pages.
//  it should be running only on qmod pages.
//  author: martinv@equisolve.com using cursor AI

document.addEventListener('DOMContentLoaded', function() {
    // Only run this script if isQmod is true
    if (typeof isQmod === 'undefined' || !isQmod) {
        return;
    }
    
    // Configuration: Add table IDs that should have responsive functionality disabled
    var targetTableIds = [
        'hd_qmod',
        // Add more table IDs here as needed
    ];
    
    // Helper functions for vanilla JS
    function extend(target, source) {
        for (var key in source) {
            if (source.hasOwnProperty(key)) {
                if (source[key] && typeof source[key] === 'object' && !source[key].nodeType) {
                    target[key] = target[key] || {};
                    extend(target[key], source[key]);
                } else {
                    target[key] = source[key];
                }
            }
        }
        return target;
    }
    
    function setData(element, key, value) {
        if (!element._dataStorage) {
            element._dataStorage = {};
        }
        element._dataStorage[key] = value;
    }
    
    function getData(element, key) {
        if (!element._dataStorage) {
            return undefined;
        }
        return element._dataStorage[key];
    }
    
    function removeData(element, key) {
        if (element._dataStorage) {
            delete element._dataStorage[key];
        }
    }
    
    // Helper function to check if table should be processed
    function shouldProcessTable(table) {
        var tableElement = table && table.nodeType ? table : document.querySelector(table);
        if (!tableElement) return false;
        
        var tableId = tableElement.getAttribute('id');
        
        // If no ID, check if it's inside a wrapper with target ID
        if (!tableId) {
            var wrapper = tableElement.closest('[id]');
            if (wrapper) {
                tableId = wrapper.getAttribute('id');
            }
        }
        
        // Check if this table ID is in our target list AND has dataTable class
        if (tableId && targetTableIds.indexOf(tableId) !== -1) {
            // Also check if the table has the dataTable CSS class
            if (tableElement.classList.contains('dataTable')) {
                return true;
            } else {
                return false;
            }
        }
        
        return false;
    }
    
    var datatablesDetected = false;
    var detectionInterval;
    
    // Method 0: Intercept DataTable initialization to prevent responsive from the start
    var originalDataTable = null;
    
    // Wait for DataTable to be available then intercept it
    var interceptTimeout = setInterval(function() {
        // Check if jQuery and DataTable are available
        if (typeof window.jq !== 'undefined' && window.jq.fn && window.jq.fn.DataTable && !originalDataTable) {
            originalDataTable = window.jq.fn.DataTable;
            var elementId = '';
            // Override the DataTable constructor
            window.jq.fn.DataTable = function(selector, options) {
                // Check if this selector targets one of our target tables
                var shouldModify = false;
                
                if (typeof selector === 'string') {
                    // Check if selector is an ID selector that matches our target list
                    if (selector.charAt(0) === '#') {
                        var selectorId = selector.substring(1);
                        shouldModify = targetTableIds.indexOf(selectorId) !== -1;
                    }
                    // Check if selector matches any of our target IDs (with or without #)
                    else {
                        shouldModify = targetTableIds.indexOf(selector) !== -1;
                    }
                } else if (selector && selector.nodeType) {
                    // DOM element passed - check its ID
                    elementId = selector.getAttribute('id');
                    shouldModify = elementId && targetTableIds.indexOf(elementId) !== -1;
                } else if (selector && selector.jquery) {
                    // jQuery object passed - check first element's ID
                    elementId = selector.attr('id');
                    shouldModify = elementId && targetTableIds.indexOf(elementId) !== -1;
                }
                
                if (shouldModify) {
                    // Force responsive to false in any configuration
                    if (options && typeof options === 'object') {
                        options.responsive = false;
                    } else if (!options) {
                        options = { responsive: false };
                    }
                }
                
                // Call the original constructor with potentially modified options
                return new originalDataTable(selector, options);
            };
            
            // Copy all static properties and methods from original
            for (var prop in originalDataTable) {
                if (originalDataTable.hasOwnProperty(prop)) {
                    window.jq.fn.DataTable[prop] = originalDataTable[prop];
                }
            }
            
            // Also intercept the jQuery plugin version
            if (window.jq.fn.dataTable) {
                var originalDataTablePlugin = window.jq.fn.dataTable;
                window.jq.fn.dataTable = function(options) {
                    // Check if this jQuery object contains one of our target tables
                    var shouldModify = false;
                    var tableInfo = '';
                    
                    this.each(function() {
                        var tableId = window.jq(this).attr('id');
                        if (tableId && targetTableIds.indexOf(tableId) !== -1) {
                            shouldModify = true;
                            tableInfo = tableId;
                            return false; // Break out of each loop
                        }
                    });
                    
                    if (shouldModify) {
                        if (options && typeof options === 'object') {
                            options.responsive = false;
                        } else if (!options) {
                            options = { responsive: false };
                        }
                    }
                    
                    return originalDataTablePlugin.call(this, options);
                };
            }
            
            clearInterval(interceptTimeout);
        }
    }, 100);
    
    // Function to reinitialize DataTable without responsive functionality
    function reinitializeDataTable(table) {
        // Double-check that this table should be processed
        if (!shouldProcessTable(table)) {
            return;
        }
        
        try {
            var tableElement = table.nodeType ? table : document.querySelector(table);
            if (!tableElement) return;
            
            // Check if jQuery DataTable API is available
            if (typeof window.jq !== 'undefined' && window.jq.fn && window.jq.fn.DataTable) {
                var $table = window.jq(tableElement);
            var dataTable = $table.DataTable ? $table.DataTable() : null;
            
                            if (dataTable) {
                
                // Get current settings and state
                var settings = dataTable.settings()[0];
                var currentPage = dataTable.page();
                var currentOrder = dataTable.order();
                var currentSearch = dataTable.search();
                
                // Store original configuration but modify responsive setting
                    var newConfig = extend({}, settings.oInit);
                newConfig.responsive = false;
                
                // Preserve important settings
                newConfig.searching = settings.oFeatures.bFilter;
                newConfig.paging = settings.oFeatures.bPaginate;
                newConfig.ordering = settings.oFeatures.bSort;
                newConfig.info = settings.oFeatures.bInfo;
                newConfig.lengthChange = settings.oFeatures.bLengthChange;
                
                // Get table ID or create one for reinitialization
                    var tableId = tableElement.getAttribute('id');
                if (!tableId) {
                    tableId = 'dt-table-' + Math.random().toString(36).substr(2, 9);
                        tableElement.setAttribute('id', tableId);
                }
                
                                    // Destroy the existing DataTable
                    dataTable.destroy();
                
                // Small delay to ensure complete cleanup
                setTimeout(function() {
                    try {
                                                    // Reinitialize with responsive: false
                            var newDataTable = new window.jq.fn.DataTable('#' + tableId, newConfig);
                        
                        // Restore previous state
                        if (currentSearch) {
                            newDataTable.search(currentSearch);
                        }
                        if (currentOrder && currentOrder.length > 0) {
                            newDataTable.order(currentOrder);
                        }
                        if (currentPage > 0) {
                            newDataTable.page(currentPage);
                        }
                        
                        // Apply changes
                        newDataTable.draw();
                        
                        // Mark as reinitialized to prevent multiple reinitializations
                            setData(tableElement, 'datatables-reinitialized', true);
                        
                                            } catch (reinitError) {
                            // Fallback to manual responsive removal
                            fallbackResponsiveRemoval(tableElement);
                        }
                }, 100);
                } else {
                    // If no DataTable instance, try manual removal
                    fallbackResponsiveRemoval(tableElement);
                }
            } else {
                // If no jQuery DataTable available, try manual removal
                fallbackResponsiveRemoval(tableElement);
            }
            
                } catch (error) {
            // Fallback to manual responsive removal  
            fallbackResponsiveRemoval(table);
        }
    }
    
    // Fallback function for manual responsive removal
    function fallbackResponsiveRemoval(table) {
        var tableElement = table.nodeType ? table : document.querySelector(table);
        if (!tableElement) return;
        
        // Check if this table should be processed
        if (!shouldProcessTable(tableElement)) {
            return;
        }
        
        // Remove responsive classes from table
        tableElement.classList.remove('dtr-inline', 'dtr-column', 'dt-responsive');
        
        // Remove responsive classes from cells
        var cells = tableElement.querySelectorAll('td, th');
        cells.forEach(function(cell) {
            cell.classList.remove('dtr-control', 'dtr-hidden');
            cell.style.display = '';
        });
        
        // Remove responsive control elements
        var detailsElements = tableElement.querySelectorAll('.dtr-details, .dtr-title');
        detailsElements.forEach(function(el) {
            el.parentNode.removeChild(el);
        });
        
        // Remove responsive breakpoint classes from wrapper
        var wrapper = tableElement.closest('.dataTables_wrapper');
        if (wrapper) {
            var className = wrapper.className;
            wrapper.className = className.replace(/dtr-\S+/g, '').trim();
        }
        
        // Remove responsive-related CSS
        tableElement.style.width = '';
        tableElement.style.minWidth = '';
        tableElement.style.maxWidth = '';
    }
    
    // Function to handle when DataTables is detected
    function onDataTablesInitialized(table) {
        
        var tableElement = table.nodeType ? table : document.querySelector(table);
        if (!tableElement) return;
        
        // Check if this table should be processed
        if (!shouldProcessTable(tableElement)) {
            return;
        }
        
        // Skip if already reinitialized
        if (getData(tableElement, 'datatables-reinitialized')) {
            return;
        }
        
        // Reinitialize DataTable without responsive functionality
        reinitializeDataTable(tableElement);
        
        // Add custom class to DataTables wrapper (after a delay to ensure reinitialization)
        setTimeout(function() {
            var wrapper = tableElement.closest('.dataTables_wrapper');
            if (wrapper) {
                wrapper.classList.add('custom-datatables');
            }
        }, 200);
        
        // Set up aggressive monitoring to prevent responsive re-activation
        // Clear any existing monitoring interval
        var existingMonitor = getData(tableElement, 'responsive-monitor');
        if (existingMonitor) {
            clearInterval(existingMonitor);
        }
        
        // Fast polling for responsive class detection
        var continuousMonitoring = setInterval(function() {
            // Check if responsive functionality has been re-enabled
            if (tableElement.classList.contains('dtr-inline') || 
                tableElement.classList.contains('dtr-column') || 
                tableElement.classList.contains('dt-responsive')) {
                removeData(tableElement, 'datatables-reinitialized');
                reinitializeDataTable(tableElement);
            }
        }, 500); // Check every 500ms for faster response
        
        // Store the monitoring interval on the table element for cleanup
        setData(tableElement, 'responsive-monitor', continuousMonitoring);
        
        // Set up MutationObserver for real-time class change detection
        if (typeof MutationObserver !== 'undefined') {
            var responsiveObserver = new MutationObserver(function(mutations) {
                mutations.forEach(function(mutation) {
                    if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
                        var target = mutation.target;
                        if (target.classList.contains('dtr-inline') || 
                            target.classList.contains('dtr-column') || 
                            target.classList.contains('dt-responsive')) {
                            
                            var targetTable = target.tagName === 'TABLE' ? target : target.querySelector('table');
                            
                            // Only process if this is a target table
                            if (targetTable && shouldProcessTable(targetTable)) {
                                removeData(targetTable, 'datatables-reinitialized');
                                reinitializeDataTable(targetTable);
                            }
                        }
                    }
                });
            });
            
            // Observe the table and its wrapper for class changes
            responsiveObserver.observe(tableElement, {
                attributes: true,
                attributeFilter: ['class']
            });
            
            var wrapper = tableElement.closest('.dataTables_wrapper');
            if (wrapper) {
                responsiveObserver.observe(wrapper, {
                    attributes: true,
                    attributeFilter: ['class']
                });
            }
            
            setData(tableElement, 'responsive-observer', responsiveObserver);
        }
        
        // Clean up monitoring after 60 seconds
        setTimeout(function() {
            clearInterval(continuousMonitoring);
            removeData(tableElement, 'responsive-monitor');
            
            var observer = getData(tableElement, 'responsive-observer');
            if (observer) {
                observer.disconnect();
                removeData(tableElement, 'responsive-observer');
            }
        }, 60000);
    }
    
    // Method 1: Listen for DataTables events (most reliable)
        document.addEventListener('init.dt', function(e) {
        if (e.detail && e.detail.settings) {
            var table = e.detail.settings.nTable;
            onDataTablesInitialized(table);
            datatablesDetected = true;
        }
    });
    
    // Also listen with jQuery if available
    if (typeof window.jq !== 'undefined') {
                window.jq(document).on('init.dt', function(e, settings) {
            var table = settings.nTable;
            onDataTablesInitialized(table);
            datatablesDetected = true;
        });
    }
    
    // Method 2: Check for DataTables periodically (fallback)
    function checkForDataTables() {
        // Check if DataTables plugin is available
        if ((typeof window.jq !== 'undefined' && window.jq.fn && (window.jq.fn.DataTable || window.jq.fn.dataTable)) ||
            (typeof window.DataTable !== 'undefined')) {
            
            // Look for tables that have been initialized with DataTables
            var dataTables = document.querySelectorAll('table.dataTable, .dataTables_wrapper table');
            dataTables.forEach(function(table) {
                // Only process if this is a target table
                if (!shouldProcessTable(table)) {
                    return;
                }
                
                if (!getData(table, 'datatables-detected')) {
                    setData(table, 'datatables-detected', true);
                    onDataTablesInitialized(table);
                    datatablesDetected = true;
                }
            });
            
            // Also check for tables with DataTables API (if jQuery is available)
            if (typeof window.jq !== 'undefined' && window.jq.fn && window.jq.fn.DataTable && window.jq.fn.DataTable.tables) {
                var apiTables = window.jq.fn.DataTable.tables(true);
                apiTables.forEach(function(table) {
                    // Only process if this is a target table
                    if (!shouldProcessTable(table)) {
                        return;
                    }
                    
                    if (!getData(table, 'datatables-detected')) {
                        setData(table, 'datatables-detected', true);
                        onDataTablesInitialized(table);
                        datatablesDetected = true;
                    }
                });
            }
        }
        
        // Stop polling after 30 seconds or if DataTables is detected
        if (datatablesDetected || Date.now() - startTime > 30000) {
            clearInterval(detectionInterval);
        }
    }
    
    // Start polling every 500ms
    var startTime = Date.now();
    detectionInterval = setInterval(checkForDataTables, 500);
    
    // Also check immediately
    checkForDataTables();
    
    // Method 4: Aggressive resize handling for DataTables
    var resizeTimeout;
    var immediateResizeTimeout;
    
    // Immediate non-debounced resize handler (runs first)
    function handleImmediateResize() {
        // Immediate synchronous action - only for target tables
        var allTables = document.querySelectorAll('table.dataTable, .dataTables_wrapper table, table.dt-responsive, .dtr-inline, .dtr-column');
        allTables.forEach(function(element) {
            var actualTable = element.tagName === 'TABLE' ? element : element.querySelector('table');
                            if (actualTable && shouldProcessTable(actualTable)) {
                removeData(actualTable, 'datatables-reinitialized'); 
                reinitializeDataTable(actualTable);
            }
        });
    }
    
    window.addEventListener('resize', handleImmediateResize);
    
    window.addEventListener('resize', function() {
        // Additional immediate action with tiny delay
        clearTimeout(immediateResizeTimeout);
        immediateResizeTimeout = setTimeout(function() {
            var dataTables = document.querySelectorAll('table.dataTable, .dataTables_wrapper table');
            dataTables.forEach(function(table) {
                // Only process target tables
                if (!shouldProcessTable(table)) {
                    return;
                }
                
                // Force immediate reinitialization on resize
                removeData(table, 'datatables-reinitialized');
                reinitializeDataTable(table);
            });
        }, 10); // Even faster response
        
        // Debounced detection restart
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(function() {
            // Reset detection flag to allow re-detection after resize
            datatablesDetected = false;
            
            // Clear existing interval and start fresh detection
            if (detectionInterval) {
                clearInterval(detectionInterval);
            }
            
            // Clear all previous detection flags to allow re-processing of target tables
            var allTables = document.querySelectorAll('table.dataTable, .dataTables_wrapper table');
            allTables.forEach(function(table) {
                // Only clear flags for target tables
                if (shouldProcessTable(table)) {
                    removeData(table, 'datatables-detected');
                    removeData(table, 'datatables-reinitialized');
                }
            });
            
            // Restart detection with new timer
            startTime = Date.now();
            detectionInterval = setInterval(checkForDataTables, 300); // More frequent checking
            
            // Multiple detection attempts with staggered timing
            setTimeout(checkForDataTables, 100);
            setTimeout(checkForDataTables, 300);
            setTimeout(checkForDataTables, 600);
            setTimeout(checkForDataTables, 1000);
        }, 150); // Shorter debounce time
    });
    
    // Method 3: MutationObserver for dynamic content (additional safety net)
    if (typeof MutationObserver !== 'undefined') {
        var observer = new MutationObserver(function(mutations) {
            mutations.forEach(function(mutation) {
                if (mutation.type === 'childList') {
                    mutation.addedNodes.forEach(function(node) {
                        if (node.nodeType === 1) { // Element node
                            var tables = [];
                            
                            // Check if the added node itself is a table
                            if (node.matches && node.matches('table.dataTable, .dataTables_wrapper')) {
                                tables.push(node);
                            }
                            
                            // Check for tables within the added node
                            if (node.querySelectorAll) {
                                var innerTables = node.querySelectorAll('table.dataTable, .dataTables_wrapper');
                                innerTables.forEach(function(table) {
                                    tables.push(table);
                                });
                            }
                            
                            tables.forEach(function(element) {
                                var table = element.tagName === 'TABLE' ? element : element.querySelector('table');
                                if (table) {
                            // Only process if this is a target table
                                    if (!shouldProcessTable(table)) {
                                return;
                            }
                            
                                                                        if (!getData(table, 'datatables-detected')) {
                                        setData(table, 'datatables-detected', true);
                                        onDataTablesInitialized(table);
                                        datatablesDetected = true;
                                    }
                                }
                            });
                        }
                    });
                }
            });
        });
        
        observer.observe(document.body, {
            childList: true,
            subtree: true
        });
        
        // Stop observing after 30 seconds
        setTimeout(function() {
            observer.disconnect();
        }, 30000);
    }
});